module.exports = __webpack_public_path__ + "static/img/70.0bf0f5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/70.png
// module id = 3oQF
// module chunks = 1